// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button {
	padding: 10px 60px;
	border-radius: 5px;
	border: var(--border);
	background-color: white;
    
}

.button:hover {
	background-color: var(--secondary-color);
}
`, "",{"version":3,"sources":["webpack://./src/components/Button/Button.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,qBAAqB;CACrB,uBAAuB;;AAExB;;AAEA;CACC,wCAAwC;AACzC","sourcesContent":[".button {\n\tpadding: 10px 60px;\n\tborder-radius: 5px;\n\tborder: var(--border);\n\tbackground-color: white;\n    \n}\n\n.button:hover {\n\tbackground-color: var(--secondary-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
